import { motion } from "framer-motion"
import PageHeaderWithInfo from "../components/common/PageHeaderWithInfo"
import { Button, Card, fadeIn, PageContainer, SearchInput, StatusBadge, Table, TableCell, TableHeader, TableRow } from "../styles/PageStyles"
import { faVcard } from "@fortawesome/free-regular-svg-icons"
import { getPipelineRuns } from '../services/pipelineService';
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { formatDate } from "../utils/dateUtils";

const Services = () => {
    const navigate = useNavigate();
    const [pipelineList, setPipelineList] = useState([]);

    const getRiskColor = (risk) => {
        switch (risk) {
            case 'low': return 'active';
            case 'medium': return 'warning';
            case 'high': return 'error';
            default: return 'default';
        }
    };

    // Get status badge color
    const getStatusColor = (status) => {
        switch (status) {
            case 'approved': return 'active';
            case 'pending': return 'default';
            case 'in-review': return 'warning';
            case 'rejected': return 'error';
            default: return 'default';
        }
    };

    const handleViewService = (serviceId) => {
        navigate(`/service-details/${serviceId}`);
    }


      useEffect(() => {
        const fetchUnderWritingPipelines = async () => {
    
          const filters = { "value_stream": "Servicing" };
          const sort = {};
          try {
            const response = await getPipelineRuns(filters, sort);
            setPipelineList(response || []);
          } catch (error) {
            console.error('Error fetching user data:', error);
            // navigate('/login'); // Redirect to login if unauthorized
          }
        };
        fetchUnderWritingPipelines();
      }, [navigate]);

    
    return(
        <PageContainer>
              <motion.div
                initial="hidden"
                animate="visible"
                variants={fadeIn}
              >
                <PageHeaderWithInfo
                  icon={faVcard}
                  title="Servicing"
                  description="AI-powered services platform that analyzes applicant data, assesses risk profiles, and provides 
                  recommendations for insurance policy approvals and pricing."
                >
                  <div style={{ display: 'flex', gap: '1rem' }}>
                    {(
                      <SearchInput
                        type="text"
                        placeholder="Search services..."
                      />
                    )}
        
                    <Button primary>New Application</Button>
                  </div>
                </PageHeaderWithInfo>

                       <Card
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.2 }}
                          >
                            {/* <CardTitle>Recent Applications</CardTitle> */}
                            <Table>
                              <thead>
                                <tr>
                                  <TableHeader>Name</TableHeader>
                                  <TableHeader>Description</TableHeader>
                                  <TableHeader>Created Date</TableHeader>
                                  <TableHeader>Status</TableHeader>
                                  <TableHeader>Actions</TableHeader>
                                </tr>
                              </thead>
                              <tbody>
                                {pipelineList.map(app => (
                                  <TableRow key={app.id}>
                                    <TableCell>{app.name}</TableCell>
                                    <TableCell>{app.transaction_description}</TableCell>
                                    <TableCell>{formatDate(app.created_at, {format:'dateTime'})}</TableCell>
                                    <TableCell>
                                      <StatusBadge status={getRiskColor(app.transaction_status)}>
                                        {app.transaction_status}
                                      </StatusBadge>
                                    </TableCell>
                                    <TableCell>
                                      <Button
                                        primary
                                        onClick={() => handleViewService(app.id)}
                                        style={{ padding: '0.4rem 0.8rem', fontSize: '0.8rem' }}
                                      >
                                        View
                                      </Button>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </tbody>
                            </Table>
                          </Card>
                </motion.div>
                </PageContainer>
    )
}

export default Services;